import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-tab-panel',
  template: `
    <div class="tab-panel" role="tabpanel">
      <ng-content></ng-content>
    </div>
  `,
})
export class TabPanelComponent {
  index = 0;
  parent?: any;
  @HostBinding('hidden') hidden = false;
  updateVisibility(activeIndex: number) {
    this.hidden = this.index !== activeIndex;
  }
}
